document.querySelectorAll('[data-illo-product]').forEach(root=>{
  const form=root.querySelector('[data-illo-form]');
  if(!form)return;
  const select=form.querySelector('[data-illo-select]');
  const variants=JSON.parse(root.querySelector('[data-illo-variants]').textContent);
  const labels=JSON.parse(root.querySelector('[data-illo-labels]').textContent);
  const buttons=[...form.querySelectorAll('[data-illo-variant]')];
  const add=form.querySelector('[data-illo-add]');
  const status=form.querySelector('[data-illo-stock]');
  const feedback=form.querySelector('[data-illo-feedback]');
  const single=variants.length===1&&variants[0].title==='Default Title';
  select.hidden=true;
  form.querySelector('.illo-native-label').hidden=true;
  form.querySelector('.illo-variants').hidden=single;
  function choose(id){
    const variant=variants.find(v=>String(v.id)===String(id));
    select.value=variant?.available?String(variant.id):'';
    buttons.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.illoVariant===String(id))));
    form.querySelector('[data-illo-choice]').textContent=variant?'— '+variant.title:'';
    if(!add)return;
    add.disabled=!variant?.available;
    add.textContent=variant?.available?labels.add+(single?'':' · '+variant.title):labels.choose;
    if(variant){
      status.textContent=variant.stock;
      root.querySelector('[data-illo-price]').innerHTML=variant.price;
      if(variant.image){const image=root.querySelector('.illo-main-image');image.src=variant.image;image.removeAttribute('srcset');}
      const url=new URL(window.location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url);
    }
  }
  buttons.forEach(button=>button.addEventListener('click',()=>choose(button.dataset.illoVariant)));
  const requested=new URL(window.location.href).searchParams.get('variant');
  if(single)choose(variants[0].id);else if(requested&&variants.some(v=>String(v.id)===requested&&v.available))choose(requested);else if(add){add.disabled=true;if(variants.some(v=>v.available))add.textContent=labels.choose;}
  form.addEventListener('submit',async event=>{
    event.preventDefault();
    if(!select.value)return;
    add.disabled=true;add.textContent=labels.adding;feedback.textContent='';
    try{
      const response=await fetch(form.action+'.js',{method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});
      const result=await response.json();
      if(!response.ok)throw new Error(result.description||labels.error);
      feedback.textContent=labels.added;
      window.location.assign((window.Shopify?.routes?.root||'/')+'cart');
    }catch(error){feedback.textContent=error.message||labels.error;choose(select.value);}
  });
});
